import { ChangeDetectionStrategy, Component, computed, inject, input, InputSignal, Signal } from '@angular/core';
import { ButtonComponent } from '@libs/common/components';
import { ProductModel } from '@libs/shop/models';
import { ProductDataModel} from '@libs/shop/models';
import { DownloadTrackingService } from '@libs/shared/tracking';

@Component({
  selector: 'ui-product-detail-data',
  templateUrl: './product-detail-data.component.html',
  styleUrl: './product-detail-data.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ButtonComponent,
  ],
})
export class ProductDetailDataComponent {
  public readonly product: InputSignal<ProductModel | undefined> = input<ProductModel>();
  public readonly productData: InputSignal<ProductDataModel | undefined> = input<ProductDataModel>();
  public readonly showProductInformationOnly: InputSignal<boolean> = input(false);

  public data: Signal<ProductDataModel | undefined> = computed(() => {
    return this.productData() ?? this.product()?.data;
  });

  public scrollElement: InputSignal<HTMLElement | undefined> = input();

  private readonly downloadTracking: DownloadTrackingService = inject(DownloadTrackingService);

  public openLMiVDocument(url: string): void {
    this.downloadTracking.trackDownload(url);
    window.open(url, '_blank', 'noopener');
  }

  public scrollToProductInfo(): void {
    if (!this.scrollElement()) {
      return;
    }

    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    this.scrollElement()!.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
}
